import ReactDOM from "react-dom/client";
import App from "./App";
import { store } from "./state/store";
import { Provider } from "react-redux";
import { BrowserView, MobileView } from "react-device-detect";
import "./index.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
	<>
		<BrowserView>
			<h1>Mobile Only Website</h1>
		</BrowserView>
		<MobileView>
			<Provider store={store}>
				<App />
			</Provider>
		</MobileView>
	</>
);
